module.exports = __webpack_public_path__ + "static/img/icon_thumb.d843b446.svg";